module.exports = __webpack_public_path__ + "static/project-4-2-46129a2569d904504814f712dd782e1c.jpg";